import css from "./ListItem.module.css";
import { IconChevronRight } from "@tabler/icons-react";

export interface IListItemProps {
  children: JSX.Element | JSX.Element[] | string;
  ariaLabel?: string;
  hideIcon?: boolean;
}

const BASE_CLASS = "f-AtomListItem";

export const ListItem = ({
  children,
  ariaLabel,
  hideIcon = false,
}: IListItemProps) => {
  return (
    <li role="listitem" aria-label={ariaLabel} className={css[BASE_CLASS]}>
      {!hideIcon && <IconChevronRight width={16} height={16} />}
      {children}
    </li>
  );
};
